import { Component, OnInit } from '@angular/core';
import { EntidadInteroperabilidadDTO } from '../../tramites/models/entidadDTO';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { TramiteService } from '../../../services/tramite.service';
import { forkJoin, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Constants } from '../../../constants/constants';
@Component({
  selector: 'app-gestion-interoperabilidad',
  templateUrl: './gestion-interoperabilidad.component.html',
  styleUrl: './gestion-interoperabilidad.component.scss',
})
export class GestionInteroperabilidadComponent implements OnInit {
  entidades: EntidadInteroperabilidadDTO[] = [];
  gestionText: any = {};
  constructor(
    private readonly tramiteService: TramiteService,
    private readonly alertService: AlertaModalService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.translate.stream('gestion_entidades').forEach(text => {
      for (const key of Object.keys(text)) {
        this.gestionText[key] = text[key];
      }
    });
    this.loadData();
  }
  selectOption(entidad: EntidadInteroperabilidadDTO, option: string): void {
    const nuevoEstado = option === 'interoperabilidad';
    entidad.selectedOption = option;
    entidad.Servicio_Disponible = option === 'interoperabilidad';

    this.tramiteService
      .editarServicioDisponible(entidad.Id, entidad.Nombre_Entidad, nuevoEstado)
      .subscribe({
        next: async () => {
          await this.alertService.exito('Estado actualizado correctamente');
        },
        error: async error => {
          await this.alertService.error('Error al actualizar el estado');

          entidad.selectedOption = nuevoEstado ? 'manual' : 'interoperabilidad';
          entidad.Servicio_Disponible = !nuevoEstado;
        },
      });
  }

  loadData(): void {
    forkJoin({
      entidades: this.tramiteService.listaEntidades(),
      fechaUltimoCorte: this.tramiteService.fechaUltimoCorteInteroperabilidadPorProceso()
    }).pipe(
      switchMap(({ entidades, fechaUltimoCorte }) => {
        const nombresCompletos$ = entidades.map(entidad => {

          if (entidad.Nombre_Entidad === Constants.SERVICIO_RUES) {
            return of(Constants.CONSULTA_RUES);
          }

          return this.tramiteService
            .obtenerNombreCompletoTramite(entidad.Codigo_Tipo_Tramite)
            .pipe(
              map(response => response.nombreCompleto)
            );
        });

        return forkJoin(nombresCompletos$).pipe(
          map(nombresCompletos => ({ entidades, fechaUltimoCorte, nombresCompletos }))
        );
      })
    ).subscribe(({ entidades, fechaUltimoCorte, nombresCompletos }) => {

      this.entidades = entidades.map((entidad, index) => {

        const date = fechaUltimoCorte.find(
          fecha => fecha.Codigo_Proceso === entidad.Codigo_Tipo_Tramite
        );

        const fecha = date?.Fecha_Registro?.split('T')?.[0];

        let format: string | undefined =
          fecha?.split('-')[2] + '/' +
          fecha?.split('-')[1] + '/' +
          fecha?.split('-')[0];

        if (!fecha) {
          format = undefined;
        }

        return {
          ...entidad,
          selectedOption: entidad.Servicio_Disponible ? 'interoperabilidad' : 'manual',
          fechaUltimoCorte: format,
          nombreCompletoTramite: nombresCompletos[index],
        };
      });
    });
  }
}
